module.exports = __webpack_public_path__ + "static/media/ico-text.773ff02a.svg";